import { Box, Card, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function EnterpriseContactCard() {
  const theme = useTheme();
  const darkMode = theme.palette.mode === 'dark';

  return (
    <Card
      sx={{
        mt: { xs: 3, sm: 4 },
        mb: { xs: 2, sm: 2 },
        px: { xs: 1.5, sm: 4, md: 6 },
        py: { xs: 2, sm: 4 },
        borderRadius: 3,
        boxShadow: darkMode
          ? '0 1px 15px -3px rgba(0,0,0,0.3), 0 4px 1px -2px rgba(0,0,0,0.2)'
          : '0 1px 15px -3px rgba(0,0,0,0.1), 0 4px 1px -2px rgba(0,0,0,0.05)',
        border: darkMode
          ? `1px solid ${theme.palette.divider}`
          : '1px solid #F1F1F1',
        background: darkMode ? theme.palette.background.paper : '#fff',
        color: darkMode ? theme.palette.text.primary : '#111827',
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 2, sm: 4 },
        transition: 'all 0.3s ease',
      }}
    >
      <Box sx={{ flex: 1, width: '100%' }}>
        <Typography
          variant="h6"
          fontWeight={700}
          sx={{
            mb: 0.5,
            fontFamily: 'Space Grotesk, sans-serif',
            color: darkMode ? theme.palette.text.primary : '#111827',
            fontSize: { xs: 16, sm: 18, md: 22 },
          }}
        >
          Enterprise Semi Managed and Fully Managed
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: darkMode ? theme.palette.text.secondary : '#111827',
            fontSize: { xs: 13, sm: 14, md: 16 },
            lineHeight: 1.5,
          }}
        >
          For custom needs, dedicated support and more, contact us to know more
          about our Enterprise Semi Managed and Fully Managed plans.
        </Typography>
      </Box>
      <Button
        variant="outlined"
        sx={{
          minWidth: { xs: '100%', sm: 200 },
          width: { xs: '100%', sm: 'auto' },
          height: { xs: 44, sm: 49 },
          borderRadius: 2,
          borderColor: '#4949C8',
          color: '#4949C8',
          fontWeight: 500,
          fontFamily: 'Space Grotesk, sans-serif',
          textTransform: 'none',
          fontSize: { xs: 14, sm: 15, md: 16 },
          ml: { sm: 4 },
          mt: { xs: 2, sm: 0 },
          '&:hover': {
            borderColor: '#4949C8',
            background: '#F6F6FF',
            color: '#4949C8',
          },
          transition: 'all 0.2s ease',
        }}
        href="#"
        fullWidth={{ xs: true, sm: false } as any}
      >
        Contact us
      </Button>
    </Card>
  );
}
